// src/themes/modern/menu/components/FilterBar.tsx
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaFilter, FaSlidersH, FaTimes } from 'react-icons/fa';
import ViewModeSwitcher from './ViewModeSwitcher';
import CategoriesComponent from './CategoriesComponent';
import { useNavigate, useParams } from 'react-router-dom';
import { useBranch } from '~/contexts/BranchContext';

interface FilterBarProps {
	showFilters: boolean;
	setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
	viewMode: "grid" | "list";
	setViewMode: React.Dispatch<React.SetStateAction<"grid" | "list">>;
}

const FilterBar: React.FC<FilterBarProps> = ({
	showFilters,
	setShowFilters,
	viewMode,
	setViewMode
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate()

	const { branch_key: branchKey, categoryId } = useParams<{ branch_key: string; categoryId?: string }>();

	const { theme, searchQuery, setSearchQuery, hasActiveFilters, handleDietaryFilterChange, clearFilters, dietaryFilters } = useBranch()

	return (
		<div
			className="sticky top-0 left-0 right-0 z-10 backdrop-blur-md shadow-md transition-all duration-300"
			style={{
				borderRadius: theme?.borderRadius,
				backgroundColor: `${theme?.backgroundColor}CC`,
				borderBottom: `1px solid ${theme?.borderColor}20`
			}}
		>
			<div 
			style={{ borderRadius: theme?.borderRadius, border: `1px solid ${theme?.borderColor}20` }}
			className="container mx-auto px-4 pt-2 pb-1 flex flex-col gap-1"
			>
			
				<CategoriesComponent
					activeCategory={categoryId ?? 'menu'}
					layout='tabs'
					onCategorySelect={(id) => {
						if (!branchKey) return;
						const basePath = `/${branchKey}/menu`;
						navigate(id === 'menu' ? basePath : `${basePath}/${id}`);
					}}
				/>
			</div>
		</div>
	);
};

interface FilterButtonProps {
	label: string;
	active: boolean;
	onClick: () => void;
	theme: any;
}

const FilterButton: React.FC<FilterButtonProps> = ({
	label,
	active,
	onClick,
	theme
}) => {
	return (
		<motion.button
			onClick={onClick}
			className="px-4 py-2 rounded-full flex items-center gap-2 cursor-pointer transition-all"
			whileHover={{ scale: 1.05 }}
			whileTap={{ scale: 0.95 }}
			style={{
				backgroundColor: active ? theme?.primaryColor : `${theme?.primaryColor}15`,
				color: active ? '#fff' : theme?.textColor,
				borderRadius: theme?.borderRadius
			}}
		>
			<span>{label}</span>
			{active && <FaFilter size={12} />}
		</motion.button>
	);
};

export default FilterBar;